import {Component, Input, OnChanges} from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { LanguagePageMixin } from 'shared/language-page/language-page-mixin';
import * as utils from 'utils/utils';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { ProductDetailsService } from '../../product-details.service';
import { ProductPanelService } from '../../../product-panel/product-panel.service';
import { PermissionsService } from 'shared/permissions/permissions.service';

@Component({
  moduleId: module.id,
  selector: 'marketing-segment',
  templateUrl: 'marketing.component.html',
  styleUrls: ['marketing.component.scss'],
})
class MarketingComponent extends BaseSegmentComponent implements LanguagePageMixin, OnChanges {

  showMore: boolean = true;
  showMoreData: any = [];
  selectedLanguage: string = 'EN';
  languagesItems: any[] = [];

  getItemLanguages: (item: any) => string[];

  getLanguagePath: (item: any) => string;

  addLanguages: (data: any) => void;

  constructor(
    private router: Router,
    protected productDetailsService: ProductDetailsService,
    protected productPanelService: ProductPanelService,
    protected permissionsService: PermissionsService,
  ) {
    super(productDetailsService, productPanelService, permissionsService);
  }

  get brands() {
    return this.itemDetail.marketing ? this.itemDetail.marketing.brand : null;
  }

  get productGroups() {
    return this.itemDetail.marketing ? this.itemDetail.marketing.product_groups : null;
  }

  get partTypes() {
    return this.itemDetail.marketing ? this.itemDetail.marketing.part_type : null;
  }

  ngOnChanges() {
    this.data = this.orderBy(this.data);
    if (_.has(this, 'itemDetail.marketing')) {
      let languages: Array<string> = [];
      _.forEach(_.keys(this.itemDetail.marketing), (segment: string) => {
        _.forEach(this.itemDetail.marketing[segment], (item: any) => {
          if (item.description) {
            const lang: Array<string> = _.keys(item.description);
            languages = _.uniq(languages.concat(lang));
          }
        });
      });
      this.addLanguages(languages);
    }
  }

  getRefLowerCase(ref: string): string {
    return _.lowerCase(ref);
  }

  // public
  public getItemProperty(item: any, path: string): any {
    let groupValue: any;
    switch (item.item_name) {
      case 'marketing.generalCopyProductGroup':
      case 'marketing.featuresAndBenefitsProductGroup':
        groupValue = _.get(this.itemDetail, item.item_name, '');
        return this.getGroupName(groupValue[this.selectedLanguage]);
      case 'marketing.generalCopyProductSubGroup':
        return this.getMarketingSubGroupName(item, 'marketing.generalCopyProductGroup');
      case 'marketing.featuresAndBenefitsProductSubGroup':
        return this.getMarketingSubGroupName(item, 'marketing.featuresAndBenefitsProductGroup');
      default:
        return super.getItemProperty(item, path);
    }
  }

  public notEmpty() {
    const data = this.itemDetail.marketing;
    return data && (data.brand || data.part_type || data.product_groups);
  }

  // handlers
  onLanguageChange(event: any) {
    this.selectedLanguage = event.code;
  }

  onEditButtonClick(segmentName: string) {
    this.router.navigate(['/global-brand-information/marketing']);
  }

  // private
  private getMarketingSubGroupName(item: any, groupPath: string) {
    const groupValue: any = _.get(this.itemDetail, groupPath, '');
    const subGroupValue: any = _.get(this.itemDetail, item.item_name, '');
    return (groupValue && subGroupValue) ?
      this.getSubGroupName(
        groupValue[this.selectedLanguage],
        subGroupValue[this.selectedLanguage]
      ) : '';
  }

  private getTypeName(item: any) {
    const field = utils.getFieldByName('type', this.data);
    const value = utils.getFieldValue(item, field);
    return value;
  }

  private getMarketingItemLanguages(item: any): string[] {
    return item.description ? _.keys(item.description) : [];
  }

}

utils.applyMixins(MarketingComponent, [LanguagePageMixin]);

export { MarketingComponent };
